<header class="navbar" [class.navbar--dark]="darkMode()">
  <div class="navbar__brand">
    <img class="navbar__logo" [src]="darkMode() ? 'assets/logo-light.png' : 'assets/logo.png'" [alt]="appName()" />
  </div>

  <nav class="navbar__controls" aria-label="Workspace controls">
    <div class="navbar__meta">
      <a class="navbar__module-link" routerLink="/localization" routerLinkActive="navbar__module-link--active"
        [routerLinkActiveOptions]="{ exact: true }">
        {{ 'navbar.module1' | translate }}
      </a>
      <a class="navbar__module-link" routerLink="/comparative-object" routerLinkActive="navbar__module-link--active"
        [routerLinkActiveOptions]="{ exact: true }">
        {{ 'navbar.module2' | translate }}
      </a>
      <a class="navbar__module-link" routerLink="/advanced" routerLinkActive="navbar__module-link--active"
        [routerLinkActiveOptions]="{ exact: true }">
        {{ 'navbar.module3' | translate }}
      </a>
      @if (showAdminModule()) {
        <a class="navbar__module-link" routerLink="/admin" routerLinkActive="navbar__module-link--active"
          [routerLinkActiveOptions]="{ exact: true }">
          {{ 'navbar.module4' | translate }}
        </a>
      }
      <span class="navbar__pulse" aria-hidden="true">
        <span class="navbar__pulse-dot"></span>
      </span>
    </div>

    <div class="navbar__actions">
      <div class="navbar__language" clickOutside (clickOutside)="closeLanguageMenu()">
        <button type="button" class="navbar__icon-btn navbar__language-trigger" [attr.aria-expanded]="languageMenuOpen"
          aria-haspopup="menu" aria-label="Language switcher" (click)="toggleLanguageMenu()">
          <span class="navbar__language-flag" aria-hidden="true">{{ selectedLanguage().flag }}</span>
        </button>

        @if (languageMenuOpen) {
        <div class="navbar__menu-card navbar__menu-card--language" role="menu" aria-label="Language options">
          <header class="navbar__menu-header">
            <span>{{ 'navbar.language' | translate }}</span>
          </header>

          @for (item of languages(); track item.value; let last = $last) {
          <button type="button" class="navbar__menu-item navbar__language-option"
            [class.navbar__language-option--active]="language() === item.value" (click)="selectLanguage(item.value)">
            <span class="navbar__language-option-flag" aria-hidden="true">{{ item.flag }}</span>
            <span class="navbar__language-option-label">{{ item.label }}</span>
            @if (language() === item.value) {
            <svg class="navbar__menu-item-trailing navbar__language-option-check" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
              <path fill="currentColor" d="m9.55 18-5.7-5.7 1.4-1.4 4.3 4.3 9.2-9.2 1.4 1.4Z" />
            </svg>
            }
          </button>
          @if (!last) {
          <div class="navbar__language-separator"></div>
          }
          }
        </div>
        }
      </div>

      <button type="button" class="navbar__icon-btn" (click)="onThemeToggle()"
        [attr.aria-label]="darkMode() ? 'Switch to light mode' : 'Switch to dark mode'">
        @if (darkMode()) {
        <svg viewBox="0 0 24 24" focusable="false">
          <path
            d="M6.76 4.84 5.34 3.42 3.92 4.84l1.42 1.42Zm10.48 0 1.42-1.42-1.42-1.42-1.42 1.42ZM12 6a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm8 5h2v2h-2ZM2 11h2v2H2Zm15.24 8.16 1.42 1.42 1.42-1.42-1.42-1.42ZM6.76 19.16l-1.42 1.42 1.42 1.42 1.42-1.42ZM11 20h2v2h-2Zm0-18h2v2h-2Z" />
        </svg>
        } @else {
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M21 12.79A9 9 0 0 1 11.21 3a1 1 0 0 0-1.11 1.49A7 7 0 1 0 19.5 13.9 1 1 0 0 0 21 12.79Z" />
        </svg>
        }
      </button>

      <div class="navbar__profile" clickOutside (clickOutside)="closeProfileMenu()">
        <button
          type="button"
          class="navbar__icon-btn navbar__icon-btn--profile"
          [attr.aria-expanded]="profileMenuOpen"
          aria-haspopup="menu"
          aria-label="Open profile menu"
          (click)="toggleProfileMenu()">
          <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.33 0-6.5 1.67-8 4.5A1 1 0 0 0 4.9 20h14.2a1 1 0 0 0 .9-1.5C18.5 15.67 15.33 14 12 14Z" />
          </svg>
        </button>

        @if (profileMenuOpen) {
        <div class="navbar__menu-card navbar__menu-card--profile" role="menu" aria-label="Profile options">
          <header class="navbar__menu-header">
            <span>{{ profileEmail() }}</span>
          </header>

          <section class="navbar__support-card" aria-label="Help Center contact">
            <div class="navbar__support-avatar" aria-hidden="true">YS</div>
            <div class="navbar__support-copy">
              <strong>{{ 'navbar.helpCenter' | translate }}</strong>
              <span>Yelyzaveta Shebalkova</span>
              <a href="mailto:31377&#64;vste.cz">31377&#64;vste.cz</a>
            </div>
          </section>

          <div class="navbar__language-separator"></div>

          <a class="navbar__menu-item navbar__menu-item--logout" [routerLink]="logoutLink()" role="menuitem" (click)="logout()">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
              <path d="M10 17v-2h5V9h-5V7h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2Zm8.71-5.71-2-2-1.42 1.42L16.59 12H7v2h9.59l-1.3 1.29 1.42 1.42ZM3 5h8V3H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v-2H3Z" />
            </svg>
            <span>{{ 'navbar.logout' | translate }}</span>
          </a>
        </div>
        }
      </div>
    </div>
  </nav>
</header>
